/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_References_Select_Space_To_BrowseInputs */



/**
* | output |
* | --- |
* | "Select a space to browse its files and folders" |
*
* @param {Project_References_Select_Space_To_BrowseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_references_select_space_to_browse = /** @type {((inputs?: Project_References_Select_Space_To_BrowseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_References_Select_Space_To_BrowseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wähle einen Space, um dessen Dateien und Ordner zu durchsuchen")
	return /** @type {LocalizedString} */ ("Select a space to browse its files and folders")
});